var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table',{ref:"notVote",attrs:{"module-info":_vm.moduleInfoResult,"toolbar-btns":[],"tb-columns":_vm.tbColumns,"on-list-data-before-load":_vm.onListDataBeforeLoad,"on-cell-click":_vm.onCellClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }